import {
  CategoryType,
  type Event,
  type EventDetails,
  type EventPreference,
} from "mws-ts-v2-sdk";

import type { ExtendedEventsOverview } from "~/types/Catalog";

const eventIsEventOverview = (
  event: Event | ExtendedEventsOverview | EventPreference,
): event is ExtendedEventsOverview => {
  return !("categories" in event);
};

export const getLogoUrlForEvent = <
  T extends Event | ExtendedEventsOverview | EventPreference,
>(
  event: T,
) => {
  let logoUrl: string | null = null;

  if (eventIsEventOverview(event)) {
    logoUrl = event.logoUrl;
  } else {
    logoUrl =
      event.categories?.find(
        (c) => c.externalReference?.type === CategoryType.Team,
      )?.logoUrl ?? null;
  }

  return logoUrl && logoUrl.length > 0 ? logoUrl : logoFallbackPath;
};

export const getBannerUrlForEvent = (
  event: EventDetails | ExtendedEventsOverview | Event,
) => {
  if (eventIsEventOverview(event)) {
    return event.bannerImageUrl && event.bannerImageUrl.length > 0
      ? event.bannerImageUrl
      : bannerFallbackPath;
  }

  if (event.bannerUrl && event.bannerUrl.length > 0) return event.bannerUrl;

  const primaryCategory = event.categories.find(
    (c) => c.externalReference?.type === CategoryType.Team,
  );

  return (
    primaryCategory?.defaultEventBannerUrl ||
    primaryCategory?.bannerUrl ||
    bannerFallbackPath
  );
};
